// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3KWTk","footer":"ModalCreateQualiphyProcedure_footer__26fmc","additionData":"ModalCreateQualiphyProcedure_additionData__3drGa"};